import config from "@/config";
import fetchWrapper from "@/services/fetchWrapper.service";

const BASE_PATH = `${config.apis.api.url}/gallery-subscriptions`;

function buildUrl(path = "") {
  if (!path) {
    return `${BASE_PATH}/`;
  }
  return `${BASE_PATH}/${path.replace(/^[/]+/, "")}`;
}

function authOptions(extra = {}) {
  return {
    injectToken: true,
    ...extra,
  };
}

async function getMine({ includeExpired = false } = {}) {
  const query = includeExpired ? "?includeExpired=true" : "";
  return fetchWrapper.get(`${buildUrl("me")}${query}`, authOptions());
}

async function createSetupIntent({ plan, billing_address, vat_id, joined_at } = {}) {
  return fetchWrapper.post(buildUrl("payment/setup-intent"), authOptions({
    body: {
      plan,
      joined_at,
      billing_address,
      vat_id,
    },
  }));
}

async function confirmPaymentMethod({
  paymentMethodId,
  intentId,
  stripe_subscription_id,
  plan,
  metadata,
  billing_address,
  vat_id,
  seat_only,
} = {}) {
  return fetchWrapper.post(buildUrl("payment/confirm"), authOptions({
    body: {
      payment_method_id: paymentMethodId,
      intent_id: intentId,
      stripe_subscription_id,
      plan,
      metadata,
      billing_address,
      vat_id,
      seat_only,
    },
  }));
}

async function verifyVatId({ vat_id, billing_address } = {}) {
  return fetchWrapper.post(buildUrl("vat/verify"), authOptions({
    body: {
      vat_id,
      billing_address,
    },
  }));
}

async function refreshVatIdStatus() {
  return fetchWrapper.post(buildUrl("vat/status"), authOptions());
}

async function getConfig() {
  return fetchWrapper.get(buildUrl("config"), authOptions());
}

async function cancelPayment() {
  return fetchWrapper.post(buildUrl("payment/cancel"), authOptions());
}

const gallerySubscriptionService = {
  getMine,
  createSetupIntent,
  confirmPaymentMethod,
  verifyVatId,
  refreshVatIdStatus,
  getConfig,
  cancelPayment,
};

export default gallerySubscriptionService;
